interface KeyMap {
  [key: string]: string;
}

export const MED_NOTIFICATION_TEXT_JA: KeyMap = {
  bigBladder: 'そろそろラインを超えました',
  urinated: 'でたかもしれません',
  gotUp: '起き上がりを検知しました',
  resetUrine: '測定が再開されました',
  dfreeDeviceRemoved: 'センサが外れています',
  upsideDown: 'センサの向きが上下逆です',
  batteryDead: '電池残量が低下しています。残尿測定は充電後に行ってください。',
  batteryAlert: 'DFree機器本体の異常を検知しました',
  connected: 'データ通信が開始されました',
  disconnected: 'データ通信が途切れました',
  default: '規定外の値です',
};

export const MED_NOTIFICATION_TEXT_EN: KeyMap = {
  bigBladder: 'Exceeded "Almost" threshold',
  urinated: '"Check" - May have urinated',
  gotUp: 'Detected getting up',
  resetUrine: 'Measurement has restarted',
  dfreeDeviceRemoved: 'DFree may not be attached',
  upsideDown: 'DFree may be upside down',
  batteryDead: 'The battery level is low. Please charge the battery before measuring post-void residual.',
  batteryAlert: 'An abnormality has been detected in the DFree device.',
  connected: 'Data communication has started',
  disconnected: 'Data communication was interrupted',
  zeroReset: 'Battery deterioration of the DFree device has been detected.',
  default: 'Error - Non-standard value',
};

export const NOTIFICATION_TEXT_JA: KeyMap = {
  disconnected: 'データ通信が途切れました(尿)',
  connected: 'データ通信が開始されました(尿)',
  urinated: 'でたかもしれません(尿)',
  bigBladder: 'そろそろラインを超えました',
  gotUp: '起き上がりを検知しました',
  resetUrine: '測定が再開されました(尿)',
  dfreeDeviceRemoved: 'センサが外れています(尿)',
  zeroReset: 'ジェルの不足や浮きをご確認ください',
  upsideDown: 'センサの向きが上下逆です(尿)',
  batteryAlert: 'DFree機器本体の異常を検知しました',
  batteryDead: 'センサの電池残量が少なくなっています(尿)',
  gasPooped: '臭いを検知しました(便)',
  gasGotUp: '起き上がりを検知しました(便)',
  gasBatteryDead: '電池残量が少なくなっています(便)',
  gasBatteryAlert: 'DFreeBenの異常を検知しました',
  gasDisconnected: 'データ通信が途切れました(便)',
  gasConnected: 'データ通信が開始されました(便)',
  gasPrediction: '排便予測時間です',
  moveUpperAdvice: 'センサの位置を上げてください',
  moveLowerAdvice: 'センサの位置を下げてください',
  default: '規定外の値です',
};

export const NOTIFICATION_TEXT_EN: KeyMap = {
  disconnected: 'Data communication was interrupted (urine)',
  connected: 'Data communication has started (urine)',
  urinated: 'Check (urine)',
  bigBladder: 'Exceeded "Almost" threshold',
  gotUp: 'Detected getting up',
  resetUrine: 'Measurement resumed',
  dfreeDeviceRemoved: 'Sensor is removed (urine)',
  zeroReset: 'Check to see if more gel is needed or make sure the device is attached to skin',
  upsideDown: 'The sensor is upside down (urine)',
  batteryAlert: 'An abnormality has been detected in the DFree device itself',
  batteryDead: 'Sensor battery is low (urine)',
  gasPooped: 'Odor detected (stool)',
  gasGotUp: 'Detected getting up (stool)',
  gasBatteryDead: 'Battery is low (stool)',
  gasBatteryAlert: 'An error was detected in DFreeBen.',
  gasDisconnected: 'Data communication has been interrupted (stool)',
  gasConnected: 'Data communication has started (stool)',
  gasPrediction: 'Predicted defecation time',
  moveUpperAdvice: 'Raise the sensor position',
  moveLowerAdvice: 'Lower the sensor position',
  default: 'Error - Non-standard value',
};

export const NOTIFICATION_ICON_PATH: KeyMap = {
  disconnected: '/images/notification/icon_disconnected.svg',
  connected: '/images/notification/icon_connected.svg',
  urinated: '/images/notification/icon_urinated.svg',
  bigBladder: '/images/notification/icon_bigbladder.svg',
  gotUp: '/images/notification/icon_gotUp.svg',
  resetUrine: '/images/notification/icon_alert.svg',
  dfreeDeviceRemoved: '/images/notification/icon_alert.svg',
  zeroReset: '/images/notification/icon_alert.svg',
  upsideDown: '/images/notification/icon_alert.svg',
  batteryAlert: '/images/notification/icon_alert.svg',
  batteryDead: '/images/notification/icon_batteryDead.svg',
  gasPooped: '/images/notification/icon_pooped.svg',
  gasGotUp: '/images/notification/icon_gotUp.svg',
  gasBatteryDead: '/images/notification/icon_batteryDead.svg',
  gasBatteryAlert: '/images/notification/icon_alert.svg',
  gasDisconnected: '/images/notification/icon_disconnected.svg',
  gasConnected: '/images/notification/icon_connected.svg',
  gasPrediction: '/images/notification/icon_prediction.svg',
  moveUpperAdvice: '/images/notification/icon_alert.svg',
  moveLowerAdvice: '/images/notification/icon_alert.svg',
  default: '/images/notification/icon_alert.svg',
};

export const NOTIFICATION_TYPE: KeyMap = {
  bigBladder: 'そろそろ',
  urinated: '出たかも',
  batteryDead: '電池切れ',
  dfreeDeviceRemoved: '外れた',
  gotUp: '起き上がり',
  resetUrine: 'リセット',
  zeroReset: 'ゼロリセット',
  upsideDown: '上下逆',
};

export const NOTIFICATION_NAME_VALUES = [
  {
    value: 'bigBladder',
    label: 'そろそろ',
  },
  {
    value: 'urinated',
    label: '出たかも',
  },
  {
    value: 'batteryDead',
    label: '電池切れ',
  },
  {
    value: 'dfreeDeviceRemoved',
    label: '外れた',
  },
  {
    value: 'gotUp',
    label: '起き上がり',
  },
  {
    value: 'resetUrine',
    label: 'リセット',
  },
  {
    value: 'zeroReset',
    label: 'ゼロリセット',
  },
  {
    value: 'upsideDown',
    label: '上下逆',
  },
];
